var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLibrary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.86917 11.6667H20V12.5C20 14.3408 18.5075 15.8333 16.6667 15.8333H8.75C7.52833 15.8333 6.5525 14.7825 6.6775 13.535C6.78583 12.4508 7.77917 11.6667 8.86917 11.6667ZM8.86917 10H20V3.33333C20 1.4925 18.5075 0 16.6667 0H10C8.15917 0 6.66667 1.4925 6.66667 3.33333V10.6758C7.2975 10.25 8.05917 10 8.86917 10ZM5.025 14.1667C5.01167 14.0492 5.00417 13.93 5.00167 13.8108H5V4.16667H3.33333C1.4925 4.16667 0 5.65917 0 7.5V14.8425C0.630833 14.4167 1.3925 14.1667 2.2025 14.1667H5.025ZM8.75 17.5C7.6925 17.5 6.67917 17.05 5.96917 16.2658C5.84583 16.1292 5.73333 15.985 5.6325 15.8333H2.2025C1.1125 15.8333 0.12 16.6175 0.0108333 17.7017C-0.114167 18.9483 0.861667 20 2.08333 20H10C11.5533 20 12.8583 18.9375 13.2283 17.5H8.75Z",
    fill: "url(#paint0_linear_192_485)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_192_485",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EDB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/library.0465e5bba8751fcb2e4e50ac5cb8d51b.svg";
export { ForwardRef as ReactComponent };